import { render, staticRenderFns } from "./indusAuto.vue?vue&type=template&id=70d94e54&scoped=true&"
import script from "./indusAuto.vue?vue&type=script&lang=js&"
export * from "./indusAuto.vue?vue&type=script&lang=js&"
import style0 from "./indusAuto.vue?vue&type=style&index=0&id=70d94e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d94e54",
  null
  
)

export default component.exports